import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const AgencyPage = () => {
  const { t } = useLanguage();

  return (
    <div 
      data-testid="agency-page" 
      className="min-h-screen pt-24"
      style={{ backgroundColor: '#050A14' }}
    >
      {/* Hero Section */}
      <section className="py-20 md:py-28 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <p 
            className="font-body text-xs tracking-[0.4em] uppercase mb-6"
            style={{ color: '#6B7280' }}
          >
            MetaLove
          </p>
          <h1 
            data-testid="agency-hero-title"
            className="font-heading text-5xl md:text-6xl lg:text-7xl font-light mb-6"
            style={{ color: '#D1D5DB' }}
          >
            {t('agency.heroTitle')}
          </h1>
          <p 
            className="font-heading text-lg md:text-xl italic"
            style={{ color: '#9CA3AF' }}
          >
            {t('agency.heroSubtitle')}
          </p>
          <div className="divider-silver w-20 mx-auto mt-12" />
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-6">
          <h2 
            className="font-heading text-3xl md:text-4xl font-light mb-8 text-center"
            style={{ color: '#D1D5DB' }}
          >
            {t('agency.visionTitle')}
          </h2>
          <div className="space-y-6 font-body text-base md:text-lg leading-relaxed text-justify" style={{ color: '#9CA3AF' }}>
            <p>{t('agency.visionText1')}</p>
            <p>{t('agency.visionText2')}</p>
          </div>
        </div>
      </section>

      {/* Approach Section */}
      <section 
        className="py-20 md:py-24"
        style={{ backgroundColor: '#070D18' }}
      >
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Logo side */}
            <div className="flex justify-center">
              <div className="relative">
                <img 
                  src="https://customer-assets.emergentagent.com/job_metalove-preview/artifacts/hs618z4m_Logo%20ML%20dore%CC%81.png"
                  alt="MetaLove"
                  className="w-40 md:w-52"
                  style={{ filter: 'brightness(0.35) sepia(0.15)', opacity: 0.35 }}
                />
              </div>
            </div>
            
            {/* Text side */}
            <div>
              <p 
                className="font-body text-xs tracking-[0.3em] uppercase mb-4"
                style={{ color: '#6B7280' }}
              >
                {t('agency.approachSubtitle')}
              </p>
              <h2 
                className="font-heading text-3xl md:text-4xl font-light mb-8"
                style={{ color: '#D1D5DB' }}
              >
                {t('agency.approachTitle')}
              </h2>
              <div className="space-y-6 font-body text-base leading-relaxed text-justify" style={{ color: '#9CA3AF' }}>
                <p>{t('agency.approachText1')}</p>
                <p>{t('agency.approachText2')}</p>
                <p>{t('agency.approachText3')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 
            className="font-heading text-3xl md:text-4xl font-light mb-10"
            style={{ color: '#D1D5DB' }}
          >
            {t('agency.philosophyTitle')}
          </h2>
          
          {/* Quote */}
          <blockquote 
            className="mb-12 py-8"
            style={{ borderTop: '1px solid rgba(156, 163, 175, 0.1)', borderBottom: '1px solid rgba(156, 163, 175, 0.1)' }}
          >
            <p 
              className="font-heading text-2xl md:text-3xl italic"
              style={{ color: '#D1D5DB' }}
            >
              {t('agency.philosophyQuote')}
            </p>
          </blockquote>
          
          <div className="space-y-6 font-body text-base md:text-lg leading-relaxed text-justify" style={{ color: '#9CA3AF' }}>
            <p>{t('agency.philosophyText1')}</p>
            <p>{t('agency.philosophyText2')}</p>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section 
        className="py-20 md:py-24"
        style={{ backgroundColor: '#070D18' }}
      >
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 
            className="font-heading text-3xl md:text-4xl font-light mb-10"
            style={{ color: '#D1D5DB' }}
          >
            {t('agency.supportTitle')}
          </h2>
          <div className="space-y-6 font-body text-base md:text-lg leading-relaxed text-justify" style={{ color: '#9CA3AF' }}>
            <p>{t('agency.supportText1')}</p>
            <p>{t('agency.supportText2')}</p>
            <p>{t('agency.supportText3')}</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32 text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 
            className="font-heading text-3xl md:text-4xl font-light mb-10"
            style={{ color: '#D1D5DB' }}
          >
            {t('agency.ctaTitle')}
          </h2>
          <Link
            to="/postuler"
            data-testid="agency-cta-button"
            className="btn-silver inline-block"
          >
            {t('agency.ctaButton')}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AgencyPage;
